import React from 'react';
import classes from './Spinner.module.css';
import SpinningLogo from './SpinningLogo';

const Spinner = () => <div className={classes['spinner-container']}>
    <SpinningLogo />
</div>;

export default Spinner;